import { Outlet } from 'react-router';
import { Header } from './Header';
import { BottomNav } from './BottomNav';

/**
 * Root app shell layout.
 * Provides the structural frame: Header at top, scrollable content area, BottomNav at bottom.
 * Uses safe-area-inset CSS env vars for Capacitor edge-to-edge display support.
 * Tier 1 (beginner) — always visible.
 */
export function AppShell(): React.ReactElement {
  return (
    <div
      className="flex h-dvh flex-col bg-background text-foreground"
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      <Header />
      <main className="flex-1 overflow-y-auto px-4 py-4">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
